module.exports = __webpack_public_path__ + "img/mie-goreng.71e34cc0.jpg";